import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  OK: null,
  NO_ACTIVE_CODE_PRESENT: null,
  EXPIRED_TOKEN: null,
  INVALID_TOKEN: null
});